import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import leftArrow from './ico-arrow-left-light.svg'
import rightArrow from './ico-arrow-right-light.svg'


class Pagination extends Component {
    constructor(props) {
        super(props);
        this.state = {value: this.props.pageNumber};

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pageNumber !== this.state.value) {
            this.setState({value: nextProps.pageNumber});
        }
    }

    handleLimitClick(limit) {
        this.props.limitChangeAction(limit);
    }

    handleInputChange(e) {
        this.setState({value: e.target.value});
    }

    render() {
        return (
            <div>
                <Container>
                    <Row>
                        <Col className="pl-3 d-none d-sm-block text-left" md="2">
                            <button type="button" 
                            id="prev-button" 
                            className="pagination-anchor-text" 
                            onClick={() => this.props.previousAction()} 
                            disabled={this.props.previousDisabled}>
                                <img alt="previous-icon" className="pl-2 pr-2" src={leftArrow} />
                                <strong>Previous</strong>
                            </button>
                        </Col>
                        <Col xs="12" md="8" className="text-center">
                            <form action="#">
                                <label htmlFor="page-number" className="hidden">Page number</label>
                                <input type="number" 
                                id="page-number" 
                                name="page-number"
                                className="pagination-page-number-input" 
                                value={this.state.value} 
                                onChange={this.handleInputChange} 
                                onKeyDown={this.props.pageNumberChangeAction} 
                                ></input>
                                <span className="pl-3">of {this.props.pageCount}</span>
                            </form>
                        </Col>
                        <Col className="d-none d-sm-block text-right pl-2" md="2">
                            <button type="button" 
                            id="next-button" 
                            className="pagination-anchor-text" 
                            onClick={() => this.props.nextAction()} 
                            disabled={this.props.nextDisabled}>
                                <strong>Next</strong>
                                <img alt="next-icon" className="pl-2 pr-3" src={rightArrow} />
                            </button>
                        </Col>
                    </Row>
                    <Row className="d-sm-none">
                        <Col className="pl-3 text-left" xs="6" >
                            <button type="button"
                            id="prev-button"
                            className="pagination-anchor-text" 
                            onClick={() => this.props.previousAction()} 
                            disabled={this.props.previousDisabled}>
                                <img alt="previous-icon" className="pl-2 pr-2" src={leftArrow} />
                                <strong>Previous</strong>
                            </button>
                        </Col>
                        <Col className="text-right pl-5" xs ="6">
                            <button type="button"
                            id="next-button" 
                            className="pagination-anchor-text" 
                            onClick={() => this.props.nextAction()} 
                            disabled={this.props.nextDisabled}>
                                <strong>Next</strong>
                                <img alt="next-icon" className="pl-2 pr-3" src={rightArrow} />
                            </button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center pt-4" xs="12">
                            <div className="btn-group">
                                {this.props.values
                                .map((item, value) => (
                                <button type="button"
                                id="pagination-number"
                                key={value} 
                                onClick={() => this.handleLimitClick(item)} 
                                className={this.props.limit === item ? "pagination-button-dark" : "pagination-button"}>
                                <strong>{item}</strong>
                                </button>))}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

}

Pagination.propTypes = {
    nextDisabled: PropTypes.bool,
    previousDisabled: PropTypes.bool,
    nextAction: PropTypes.func,
    previousAction: PropTypes.func,
    limit: PropTypes.number,
    limitChangeAction: PropTypes.func,
    values: PropTypes.array,
    pageNumberChangeAction: PropTypes.func,
    pageCount: PropTypes.number,
    pageNumber: PropTypes.number,
    showPageControl: PropTypes.bool,
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/common/Pagination/Pagination.js